import type { CombinedSampleResponse } from '~/clients'
import { SampleLevel, SampleStatus } from '~/types/Samples'

type SampleActionFields = Pick<CombinedSampleResponse, 'status' | 'level'> &
  Partial<Pick<CombinedSampleResponse, 'location'>>

const canShareSampleAndCopySample = (sample: SampleActionFields, locationIds: number[]) => {
  return (
    sample.status === SampleStatus.Final &&
    sample.level === SampleLevel.Own &&
    !!sample.location &&
    locationIds?.includes(sample.location.id)
  )
}

function sampleHasReports(item: Pick<CombinedSampleResponse, 'status'>) {
  const sampleStatusses = [SampleStatus.Analysed, SampleStatus.Final, SampleStatus.Copied]

  return sampleStatusses.includes(item.status)
}

export { canShareSampleAndCopySample, sampleHasReports }
